export default {
  PRICING_HEADING: 'Unsere flexiblen Preismodelle',
  OPTION: [
    {
      HEADING: 'Standard-Auftrag',
      TEXT: '15 - ∞ Tage Vorlauf',
      SMALL_TEXT:
        'Wir vermitteln Ihnen schnell und papierlos geprüfte Vertretungsärzte - Dienstvertretungsvertragsvorlage inklusive. Sie haben die Kontrolle über die Auswahl des Vertreters. Über Ihren persönlichen Zugang verwalten Sie Ihre Betriebsstätten, Ärzte und Dienste und können Statusinformationen einsehen. Bei Notfällen erreichen Sie uns 24/7.',
    },
    {
      HEADING: 'Eil-Auftrag',
      TEXT: '4 bis 14 Tage Vorlauf',
      SMALL_TEXT:
        'Sie erhalten alle Vorzüge des Standard-Auftrags. Zusätzlich stellen wir Ihnen einen persönlichen Ansprechpartner für Ihren KV-Dienst zu Seite. Damit Sie das Maxumum herausholen, erhalten Sie eine Anleitung zur Optimierung Ihrer Inseraten mit Checkliste (Material,..)',
    },
    {
      HEADING: 'Express-Auftrag',
      TEXT: '3 Tage oder weniger Vorlauf',
      SMALL_TEXT:
        'Sie übergeben uns digital die Dienstdaten, wir kümmern uns den Rest: Dabei erhalten Sie alle Vorteile des Eil-Auftrags. Zudem organisieren wir für Sie die Bewerberanfragen im Rahmen Ihrer Honorarvorgaben.',
    },
    {
      HEADING: 'Rundum-Sorglos-Paket',
      TEXT: 'Möglich ab 15 Tagen Vorlauf',
      SMALL_TEXT: 'Sie erhalten alle Vorteile des Express-Auftrags. Darüber hinaus organisieren wir für Sie die rechtzeitige Versendung von KL und Unterlagen.',
    },
  ],
};
